import { Flow } from '@/components/Flow';
import { Step } from '@/components/Step';

export const NaturalPerson = () => {
  return (
    <Flow>
      <Flow.Progress label='Verificação de identidade' />

      <Flow.StepList>
        <Step name='face-detection' />
        <Step name='document-natural' />

        <Step name='phone-natural' />
        <Step name='address' />
        <Step name='occupation-natural' />
        <Step name='income-natural' />
        <Step name='pep-natural' />
        <Step name='bank-account' />
        <Step name='terms' />
      </Flow.StepList>
    </Flow>
  );
};
